/**
 * Everything in this package that could change an answer is versioned, and the version travels with the answer.
 *
 * Three of them, because they move independently: the geometry can be re-derived without touching a rule, a rule can be re-tuned without changing a gate, and a gate can be loosened after a real-capture study without either. A stored assessment that names all three can always be explained later, which is the whole point of a rule-based classifier.
 */

/** Outline extraction, pose normalisation, the width profile and the eight features. */
export const GEOMETRY_VERSION = 'face-geometry-v0.1';

/** The membership functions, the per-shape scores and the CLEAR / MIXED / UNKNOWN decision. */
export const CLASSIFIER_VERSION = 'face-shape-rules-v0.1';

/** The geometry-quality gates and their thresholds. */
export const GATE_CONFIG_VERSION = 'face-gates-v0.1';

export interface FaceVisionVersions {
  geometry: string;
  classifier: string;
  gates: string;
}

export const VERSIONS: FaceVisionVersions = {
  geometry: GEOMETRY_VERSION,
  classifier: CLASSIFIER_VERSION,
  gates: GATE_CONFIG_VERSION,
};
